<template>
    <div class="app-title">
        <a @click="goHome" v-if="!isHomePage"><i class="el-icon-arrow-left"></i></a>
        <router-link to="/">
            <img src="img/logo.png" title="自助制图系统">
        </router-link>
        <span class="app-name" @click="redirectToHome">{{name}}</span>
    </div>
</template>
<script>
    const def_name = '自助制图系统'
    export default {
        props:{
            isHomePage: {
                type: Boolean, default: true
            },
            name: {
                type: String, default:  def_name
            },
            homeUrl: {
              type: String, default: ''
            }
        },
        created(){
        },
        methods: {
            redirectToHome(){
                if(this.name === def_name){
                   window.location.href = '/';
                }
            },
            goHome () {
                let fromPath = sessionStorage.getItem('from') || '/';
                this.$router.push(fromPath)
            }
        }
    };
</script>